import { helpers } from "vuelidate/lib/validators";
/**
 * Custom validators for use with Vuelidate library
 * @const phone regex checks if valid phone number, ignores formatting
 */

export const phone = helpers.regex(
  "phone",
  /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/
);

export const arrayLenEven = value =>
  value && (value.length === 1 || value.length % 2 === 0);
